var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[_c('v-responsive',{attrs:{"id":"app-wrapper","min-width":"1280px"}},[_c('tw-navigation'),_vm._v(" "),_c('tw-main-toolbar'),_vm._v(" "),_c('tw-content-wrapper',[_c('router-view')],1)],1)],1),_vm._v(" "),_c('vue-progress-bar')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cb8a98c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 